import type { ConversionFormStep, ConversionFormStepField, FieldBuilderComponentsType, FieldBuilderComponentType } from '../types';
import { makeFieldId } from '../utils/makeFieldId';
import { CheckboxGroup } from './CheckboxGroup';
import { CompanyName, Email, FullNameInput, Message, NumberInput, Phone, Slider, TextInput, URL } from './Input';
import { RadioImageInput, RadioInput } from './RadioGroup';
import { RichTextField } from './RichText';
type FieldBuilderProps = {
  step: ConversionFormStep;
};
const fieldsByTypename = {
  ConversionFormStepsFieldsInputField: TextInput,
  ConversionFormStepsFieldsNumberField: NumberInput,
  ConversionFormStepsFieldsRadioList: RadioInput,
  ConversionFormStepsFieldsRadioImageList: RadioImageInput,
  ConversionFormStepsFieldsCheckboxList: CheckboxGroup,
  ConversionFormStepsFieldsFullNameField: FullNameInput,
  ConversionFormStepsFieldsPhoneNumberField: Phone,
  ConversionFormStepsFieldsEmailField: Email,
  ConversionFormStepsFieldsCompanyNameField: CompanyName,
  ConversionFormStepsFieldsUrlField: URL,
  ConversionFormStepsFieldsMessageField: Message,
  ConversionFormStepsFieldsSliderField: Slider,
  ConversionFormStepsFieldsRichText: RichTextField
} satisfies FieldBuilderComponentsType;
export function FieldBuilder({
  step
}: FieldBuilderProps) {
  const fields = step.fields?.filter((f): f is ConversionFormStepField => f != null) ?? [];
  return <>
      {fields.map((field, i) => {
      if (!field || !field.__typename) {
        return null;
      }
      const name = makeFieldId(step?.name ?? '', field?.label ?? `field-${i}`);
      const Component = fieldsByTypename[field.__typename as keyof typeof fieldsByTypename] as FieldBuilderComponentType<typeof field.__typename>;
      if (Component == null) {
        return null;
      }
      return <Component key={name} data={field} name={name} />;
    })}
    </>;
}